import { Temporal } from 'temporal-polyfill';

export enum TimeMeridiem {
  AM = 'AM',
  PM = 'PM',
}

export interface FormInputTimeColumnsProps {
  value: Temporal.PlainTime | undefined;
  onChange: (value: Temporal.PlainTime) => void;
  step: Temporal.Duration;
  min: Temporal.PlainTime;
  max: Temporal.PlainTime;
  className?: string;
  addMax?: boolean;
  footerAction?: {
    label: string;
    onClick: (options: { closePopover: () => void }) => void;
  };
}

export function computeValidTimeColumns(
  step: Temporal.Duration,
  min: Temporal.PlainTime,
  max: Temporal.PlainTime,
): { validHours: string[]; validMinutes: string[]; validMeridiems: TimeMeridiem[] } {
  const stepMinutes = step.total({ unit: 'minutes' });

  const hourSet = new Set<string>();
  const minuteSet = new Set<string>();
  const meridiemSet = new Set<TimeMeridiem>();

  const minTotal = min.hour * 60 + min.minute;
  const maxTotal = max.hour * 60 + max.minute;

  for (let total = minTotal; total <= maxTotal; total += stepMinutes) {
    const hour = Math.floor(total / 60);
    const minute = total % 60;
    const hour12 = hour % 12 || 12;
    const meridiem = hour >= 12 ? TimeMeridiem.PM : TimeMeridiem.AM;

    hourSet.add(hour12.toString().padStart(2, '0'));
    minuteSet.add(minute.toString().padStart(2, '0'));
    meridiemSet.add(meridiem);
  }

  return {
    validHours: Array.from(hourSet).sort(),
    validMinutes: Array.from(minuteSet).sort(),
    validMeridiems: Array.from(meridiemSet),
  };
}

export function to24HourFormat(hour: number, meridiem: TimeMeridiem): number {
  if (meridiem === TimeMeridiem.AM) {
    return hour === 12 ? 0 : hour;
  }

  return hour === 12 ? 12 : hour + 12;
}

export function from24HourFormat(hour24: number): { hour12: number; meridiem: TimeMeridiem } {
  const meridiem = hour24 >= 12 ? TimeMeridiem.PM : TimeMeridiem.AM;
  const hour12 = hour24 % 12 || 12;

  return {
    hour12,
    meridiem,
  };
}
